// ────────────────────────────────────────────────────────────
// useLens — hook to read effective lens for a deal
// ────────────────────────────────────────────────────────────
// Effective lens = override (if set) ?? lensFromCenterTab(centerTab)
// Returns { lens, isAuto, setLens }

import { useUIStore } from '../store/ui';
import { lensFromCenterTab } from '../lib/lens';
import type { Lens } from '../types';

export interface UseLens {
  lens: Lens;
  isAuto: boolean;
  setLens: (lens: Lens | null) => void;
}

export function useLens(dealId: string | null): UseLens {
  const { centerTab, lensOverride, setLensOverride } = useUIStore();
  if (!dealId) return { lens: 'general', isAuto: true, setLens: () => {} };

  const tab = centerTab[dealId] ?? 'overview';
  const override = lensOverride[dealId] ?? null;
  const lens: Lens = override ?? lensFromCenterTab(tab);
  return {
    lens,
    isAuto: !override,
    setLens: (l: Lens | null) => setLensOverride(dealId, l),
  };
}
